import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numIssues: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.num-issues',
		defaultMessage: '{numIssues} {numIssues, plural, one {issue} other {issues}}',
		description: 'Display the number of issues per deployment',
	},
	overTwelveWeekMedian: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.over-twelve-week-median',
		defaultMessage: 'Over 12-week median',
		description:
			'Hover tooltip when mouse is hovered over up icon indicating the issues per deployment is over the 12-week median',
	},
	underTwelveWeekMedian: {
		id: 'software-deployment-frequency-report.per-deployment-detail-table.jira-issues-per-deployment-cell-content.under-twelve-week-median',
		defaultMessage: 'Under 12-week median',
		description:
			'Hover tooltip when mouse is hovered over down icon indicating the issues per deployment is under the 12-week median',
	},
});
